<div class="ddr-add-reminder-dialog">
  <div>
    <span style="font-weight: bold;">Create reminder</span>
  </div>
  <div class="import-dialog-content">
    <p>Feedback due date: <strong>{{feedbackDueDate}}</strong></p>
    <ng-container *ngIf="isDataLoaded">
      <div class="reminder-date-section">
        <p>Set reminder date:</p>
        <owc-datepicker 
          style="width: 50%;" 
          variant="outlined" 
          format="dd-MMM-yyyy" 
          label="Reminder date" 
          [formControl]="reminderDate"
          [disabledDates]="feedbackDueDateDisabled" 
          (valueChange)="onReminderDateSelected($event)"
          (owcChange)="onReminderDateSelected($event)"
          #reminderDatepicker 
          panelClass="one-datepicker">
        </owc-datepicker>

      </div>
    </ng-container>
    <div class="reminder-datepicker-container" *ngIf="isDataLoaded">
      <div class="one-quick-selection">
        <div class="one-quick-selection-title">Select reminder date</div>
        <owc-radio-group #radioGroupElement (valueChange)="radioChange($event)" class="example-date-picker-radio-group">
          <owc-radio class="example-radio-button" value="7" [disabled]="dueDateDiff <= 7">One week before due date
          </owc-radio>
          <owc-radio class="example-radio-button" value="14" [disabled]="dueDateDiff <= 14">Two weeks before due date
          </owc-radio>
        </owc-radio-group>
      </div>
    </div>
    <div class="reminder-message-section">
      <p>Add a reminder message:</p>
      <div class="msg-attach-subject">
        <owc-input variant="outlined" label="Subject" value="Outlined input" [formControl]="subjectName" type="text"
          (keyup)="onKeyupSubjectName($event)" (blur)="onBlurSubjectName($event)" min="5" max="250" />
      </div>
      <dl-rich-text-document [jsonTextItem]="reminderRTEDoc"
        (jsonTextReturn)="setRTEText($event)"></dl-rich-text-document>
      <div class="msg-attach-templete-apply">
        <owc-checkbox [(ngModel)]="addTempleteCheck" [disabled]="disabledApplyCheckbox" style="flex:1">Add this reminder
          message to your templates</owc-checkbox>
      </div>
    </div>

  </div>
  <div class="import-dialog-actions" style="display: flex;">
    <owc-button (click)="onCancel()" class="cancel-btn">Cancel</owc-button>
    <owc-button *ngIf="!isEditRow" color="primary"
      [disabled]="!subjectName.value || !reminderDate.value || reminderDate.invalid || !reminderRTEDoc  || reminderRTEDoc =='<p></p>'"
      (click)="addReminder()">
      Add
    </owc-button>
    <owc-button *ngIf="isEditRow" color="primary"
      [disabled]="!subjectName.value || !reminderDate.value || reminderDate.invalid || !createReminderTxt || createReminderTxt=='<p></p>'"
      (click)="updateReminder()">
      Update
    </owc-button>
  </div>
</div>